import * as React from 'react';
import { baseUrl } from '../baseUrl'
// import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
// import Container from '@mui/material/Container';
import { createTheme, ThemeProvider} from '@mui/material/styles';
import { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import Link from '@mui/material/Link';
// import LoginScreenImage from '../images/LoginScreenimage2.jpg';
import YayaplayerLogo from '../images/yayaplayerlogo.png';
import SignIn from '../images/SignIn.png';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" target='_blank' href="https://beeitech.com/privacy_policy">
        YaYa Player
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: 'rgb(255, 53, 3)',
    },
    secondary: {
      main: 'rgb(0, 0, 0)',
    },
  },
};

const defaultTheme = createTheme(themeOptions);

export default function Login() {
  // const [email,setemail] = useState('')
  const[username,setUsername] = useState('')
  const [password,setpassword] = useState('')
  // const [adminNameError, setAdminNameError] = useState('');
  // const [passwordError, setPasswordError] = useState('');
  const [loginStatus, setLoginStatus] = useState('false');
  const navigate = useNavigate();
  const handleSubmit = async(event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // console.log({
    //   username: data.get('username'),
    //   password: data.get('password'),
    // });
    try {
      const response = await axios.post(`${baseUrl}adminlogin`,{ email:username, password:password});
      // console.log(response);

      if (response.data && response.data.status_code === 200) {
        setLoginStatus(true);
        navigate('/cms/dashboard',{state:{username,loginStatus}});
        // setLoginStatus('Login successful');
      } else {
        // setLoginStatus('User name or password is incorrect');
        alert('User name or password is incorrect')
      }
    } 
    catch (error) {
      console.error('Error:', error);
      setLoginStatus('An error occurred during login');
      alert('An error occurred during login')
    }
  }



  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${SignIn})`,
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition:'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyItems:'center'
            }}
          >
            {/* <Avatar sx={{ m: 1, bgcolor:'secondary.main'}}>
              <LockOutlinedIcon />
            </Avatar> */}
            <img style={{width:'50px',height:'50px'}} src={YayaplayerLogo} alt='logo'/>
            {/* <Typography component="h1" variant="h5">
              MyPalyer  
            </Typography> */}
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="User name"
                name="username"
                autoComplete="username"
                autoFocus
                value = {username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value = {password}
                onChange={(event) => {
                  setpassword(event.target.value);
                }}
              />
              {/* <FormControlLabel noValidate
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                LOGIN
              </Button>
              <Grid container sx={{justifyContent:'space-between'}}>
                <Grid item>
                  {/* <Link href="/forgotpassword" variant="body2">
                    Forgot password?
                  </Link> */}
                </Grid>
                <Grid item>
                  {/* <Link href="/signup" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link> */}
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} /> 
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>

  );
}